import { LegalBackLink } from "@/components/legal-back-link";
import { LegalFooter } from "@/components/legal-footer";

const H1 = "text-3xl font-bold tracking-tight";
const H2 = "text-xl font-semibold mt-10 mb-3";
const P = "leading-relaxed text-muted-foreground";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen flex items-start justify-center py-12 px-4">
      <div className="w-full max-w-3xl">
        <div className="mb-6">
          <LegalBackLink />
        </div>

        <header className="mb-10">
          <h1 className={H1}>Privacy Policy</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: 2026-05-04</p>
        </header>

        <article>
          <p className={P}>
            Quantfolio AS ("we", "us", "our") provides the Quantfolio Platform ("Service"). This
            Privacy Policy explains how we collect, use, and protect personal data when you use the
            Service.
          </p>

          <h2 className={H2}>1. Data we process</h2>
          <ul className="list-disc pl-6 space-y-2 text-muted-foreground leading-relaxed">
            <li>
              <strong className="text-foreground">Account data</strong> — name, email, organisation,
              authentication metadata required to operate your account.
            </li>
            <li>
              <strong className="text-foreground">Customer data</strong> — information you upload or
              generate while using the Service. We process this on your behalf as a data processor.
            </li>
            <li>
              <strong className="text-foreground">Usage data</strong> — logs, IP addresses, device
              and browser information, and performance metrics used to operate and secure the
              Service.
            </li>
          </ul>

          <h2 className={H2}>2. How we use data</h2>
          <p className={P}>
            We use personal data to provide and operate the Service, communicate with you about your
            account, ensure security and integrity, comply with legal obligations, and improve the
            Service.
          </p>

          <h2 className={H2}>3. Sharing</h2>
          <p className={P}>
            We share data with sub-processors who help us deliver the Service (such as hosting,
            email delivery, analytics, identity verification). We require appropriate contractual
            safeguards. We do not sell personal data.
          </p>

          <h2 className={H2}>4. Retention</h2>
          <p className={P}>
            We retain personal data for as long as necessary to provide the Service and comply with
            our legal obligations. Customer data is retained according to your instructions and
            applicable agreements.
          </p>

          <h2 className={H2}>5. Your rights</h2>
          <p className={P}>
            Depending on your jurisdiction you may have rights to access, correct, delete, or export
            your personal data, and to object to or restrict certain processing. Contact us to
            exercise these rights.
          </p>

          <h2 className={H2}>6. Security</h2>
          <p className={P}>
            We use industry-standard technical and organisational measures to protect personal data,
            including encryption in transit and at rest for sensitive fields.
          </p>

          <h2 className={H2}>7. Changes</h2>
          <p className={P}>
            We may update this Privacy Policy from time to time. Material changes will be
            communicated through the Service or by email.
          </p>

          <h2 className={H2}>8. Contact</h2>
          <p className={P}>
            For privacy questions or to exercise your rights, contact{" "}
            <a href="mailto:hello@quantfol.io" className="underline hover:text-foreground">
              hello@quantfol.io
            </a>
            .
          </p>
        </article>

        <LegalFooter />
      </div>
    </div>
  );
}
